import React, { useState } from 'react';

const EYE = 'M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12zM12 15a3 3 0 100-6 3 3 0 000 6z';
const EYE_OFF = 'M3 3l18 18M10.6 5.1A10.700 10.700 0 0112 5c7 0 11 7 11 7a18 18 0 01-3.200 4M6.600 6.600A18 18 0 001 12s4 7 11 7c1.700 0 3.200-.4 4.500-1M9.900 9.900a3 3 0 004.200 4.200';

/**
 * A password field with a show/hide eye. Takes the same props as <input>; `wrapperStyle` styles the
 * box around it, so margins on the field itself don't push the eye out of line.
 */
const PasswordInput = ({ style, wrapperStyle, ...props }) => {
  const [shown, setShown] = useState(false);
  return (
    <div style={{ position: 'relative', width: '100%', ...wrapperStyle }}>
      <input {...props} type={shown ? 'text' : 'password'} style={{ ...style, width: '100%', paddingRight: 46, boxSizing: 'border-box' }} />
      <button
        type="button"
        onClick={() => setShown((s) => !s)}
        aria-label={shown ? 'Hide password' : 'Show password'}
        aria-pressed={shown}
        style={{
          position: 'absolute', right: 4, top: '50%', transform: 'translateY(-50%)', width: 40, height: 40,
          display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
          border: 0, background: 'none', color: '#5a6a7e', cursor: 'pointer', borderRadius: 8,
        }}
      >
        <svg aria-hidden="true" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d={shown ? EYE_OFF : EYE} />
        </svg>
      </button>
    </div>
  );
};

export default PasswordInput;
